<template>
	<section style="width: 100%;height: 100%;">

      <mu-row class="main_nav">
        <mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
          <mu-col width="10" tablet="10" desktop="10">

      <mu-avatar size="65">
            <img src="/static/img/logo.png">
          </mu-avatar>
      </mu-col>
        <mu-col width="50" tablet="50" desktop="50">
          <mu-tabs value="tab0" class="main_nav">
            <template v-for="(item, index) in modules">
              <mu-tab :title="item.name" :key="item.pkid" :index="item.pkid" @click="openNewWindow(item.href)" :value="setValue(index)"></mu-tab>
            </template>
          </mu-tabs>
        </mu-col>
        <mu-col width="10" tablet="10" desktop="10">     <div  style=" color:white; padding:0 30px;cursor: default">

                <template v-if="userInfo">
                  <div class="user-detail">

                    <mu-icon value="account_circle" size="36" style="    display: inline-block;   vertical-align: middle;"></mu-icon>

                    <span class="user-name" @click="openNewWindow(UserCenterLocation + '#0')">{{ username }}&nbsp;&nbsp;</span>

                  </div>
                </template>
                <template v-else>
                  <div class="user-detail">登录</div>
                </template>
              </div></mu-col>
        <mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
      </mu-row>



    <div style="width: 100%;height: 100%;">
    	<iframe :src="srcParam" width="100%" height="100%"  frameborder="no" border="0" marginwidth="0" marginheight="0" allowtransparency="yes">

    	</iframe>



    </div>


		<div class="foot" style="position: fixed;width: -webkit-fill-available;bottom: 0px;">
			<div class="col-md-12 rows">
				<div class="footHrefOuter">
					<p class="footHref3" style="background: rgb(204, 204, 204); font-size: 12px;">
						<span>
							版权所有@ 2008-2018 济南市自然资源和规划局 技术支持：北京超图股份有限公司
						</span>
					</p>
				</div>
			</div>
		</div>
	</section>
</template>
<script type="text/javascript">
import axios from 'axios';
import $ from 'jquery';
import { getUserMessage } from '@/apis/api';
import { Geoesbmengine, Usercenter, Cas, Nav, Editmanager, Map, Webframe,dataThemesConfig } from '@/config/app-config';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;
let host = APPCONFIG.IP,
	casLogout = Cas.location + '/logout';
export default {
	components: {},
	data() {
		return {
			modules: [],
			srcParam:"",
			usershortname: '游客',
			userMsgCount: 0,
				host: host,
			userid: '',
			userInfo: null,
			username: '游客',
			loginTextShow: true,
			supervisePoints: [],
		};
	},


	methods: {
		changeTabs(val) {
			this.active = val;
		},
		getUserInfo() {
			let that = this;
			axios.get(APPCONFIG.GetUserInfoUrl).then(function(e) {
				if (e.data && e.data.resultInfo) {
					that.userInfo = e.data.resultInfo.data;
					that.userid = e.data.resultInfo.data.pkid;
					that.username = e.data.resultInfo.data.usershortname;
					that.loginTextShow = false;
					that.getMapModule(that.userid);
				}
			});
		},

		setValue(index) {
			return 'tab' + index;
		},
		returnImgUrl(pkid) {
			return APPCONFIG.serviceImgUrl + pkid;
		},
		returnErrorUrl() {
			return APPCONFIG.host + '/skywebframe/images/404.png';
		},
		getUserMessage() {
			if (this.userInfo) {
				getUserMessage().then(res => {
					let result = res.data.resultInfo;
					if (result.success) {
						let count = result.data.sum;
						if (count > 99) {
							this.userMsgCount = '99+';
						} else {
							this.userMsgCount = count;
						}
					}
				});
			}
		},
		getMapModule(id) {
			let that = this;
			axios.get(APPCONFIG.GetMoudlesUrl + id + '.json').then(function(e) {
				if (e.data && e.data.data) {
					that.modules = e.data.data.modules[0].children[0].children;
				}
			});
		},
		scrollHtml(len) {
			var h = $(window).scrollTop(); //获取当前滚动条距离顶部的位置
			$('html,body').animate({ scrollTop: document.getElementById(len).offsetTop - 50 }, 800); //点击按钮向下移动800px，时间为800毫秒
		},
		getServicesInfo(themeId) {
			var that = this;
			axios.get(APPCONFIG.GetServicesUrl + '?pagesize=10&pageindex=1&specCode=' + themeId).then(function(e) {
				if (e.data && e.data.resultInfo) {
					that.servicesInfos = e.data.resultInfo.data.items;
					if (that.servicesInfos.length > 4) that.servicesInfos.length = 4;
				}
			});
		},
		returnStyle(url) {
			return 'background: url(' + url + ') no-repeat';
		},
		logout() {
			let url = this.userInfo ? casLogout + '?userid=' + this.userInfo.pkid : casLogout;
			window.location.href = url;
		},
		openNewWindow(location) {
			if (location.indexOf('no_no') > -1) {
				alert('功能完善中...');
			} else {
				window.open(location, '_blank');
			}
		},



	},
	mounted() {
		let that = this;
		this.getUserInfo();
		this.getServicesInfo(dataThemesConfig[0].theme);
		$('#J-ali-main-specail li').hover(
			function() {
				$(this)
					.removeClass()
					.addClass('hover');
			},
			function() {
				$(this).removeClass();
			}
		);
		$('.cloud1').on('click', function() {
			//_self.common.scroll('#cloud', 1000);
			window.open('/map', '_blank');
		});
		let src=window.location.href.split('=')[1].split("%2F");

		//this.srcParam="https://192.168.0.187:8080/portal/services/news/news/show/"+src[6]+"/"+src[7];
		this.srcParam="https://"+window.location.host+"/portal/services/news/news/show/"+src[6]+"/"+src[7];

	}
};
</script>
<style type="text/css">
body,html{
	 margin: 0px 0px;
	height: 100%;
	width: 100%;
}
iframe{
	 margin: 0px 0px;
	 width: 100%;
	 height: 100%;
}
#app{
	 margin: 0px 0px;
	 width: 100%;
	 height: 100%;
}
/**
 * 新闻
 */
  .newsClass{
    color:black;
    font-size: 14px;
  }
.news{
   width:100%;
   height: 450px;
}

/**
 * 轮播图
 */
.news_moduel1{
  width: 600px;
  float: left;
  margin-left:385px;
  margin-top: 20px;
}
.news_moduel2{
  width: 485px;
  float: left;
  margin-left:40px;
  margin-top:-70px;
  font-size: 20px;
}


.nav_3_img .mu-card-header-title .mu-card-title {
	font-size: 20px;
}
.media-body h4 {
	font-size: 18px;
}
.themesName {
	position: absolute;
	bottom: 30%;
	left: 1.5%;
	color: white;
	width: 81%;
	height: 25%;
	background-color: rgba(128, 128, 128, 0.8);
	font-size: 23px;
	font-weight: bold;
	padding-left: 5%;
	padding-top: 2%;
}
.themesInfo {
	padding-left: 4%;
}
.media-body p {
	font-size: 14px;
}
/* navigation
-------------------------------------------------- */
.navigation .ali-main-special {
	position: relative;
	width: 100%;
	height: 120px;
	padding: 0px;
	margin: 30px 0;
	text-align: right;
}
.navigation .ali-main-special .media {
	cursor: pointer;
}

.navigation .ali-main-special li {
	position: relative;
	height: 120px;
	display: block;
	width: 20%;
	float: left;
}
.navigation .ali-main-special .hover h4 {
	color: #004d8c;
}
.navigation .ali-main-special li:before,
.navigation .ali-main-special li:after {
	content: '';
	position: absolute;
	width: 1px;
	height: 100%;
	background: #d8d8d8;
	top: 0;
	z-index: 2;
}
.navigation .ali-main-special li:before {
	left: 0;
	margin-left: -1px;
}
.navigation .ali-main-special li:after {
	right: 0;
}

.navigation .ali-main-special li a {
	padding: 0 1px;
	display: block;
	width: 100%;
	height: 100%;
}

.navigation .ali-main-special li .bg-item {
	-webkit-transition: all 0.3s;
	-moz-transition: all 0.3s;
	-o-transition: all 0.3s;
	transition: all 0.3s;
	position: absolute;
	top: -17px;
	left: 6px;
}
.navigation .ali-main-special li .bg-normal {
	width: 100%;
	opacity: 1;
	-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
}
.navigation .ali-main-special li .bg-hover {
	width: 100%;
	opacity: 0;
	-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';
}
.navigation .ali-main-special li.hover .bg-normal {
	opacity: 0;
	-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';
}
.navigation .ali-main-special li.hover .bg-hover {
	opacity: 1;
	-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
}
.navigation .media-body {
	padding-left: 120px;
	text-align: left;
	padding-top: 25px;
}
.navigation .media-body a {
	color: rgb(34, 34, 34);
}
/*--------------------------------------------------------------------*/
.mu-tab-active {
	color: red !important;
}

body {
	min-width: 1910px;
	overflow-x: auto !important;
}
/*.user-detail{
	width:200px;
	margin-top: 15px;
}*/
.user-detail span {
	cursor: pointer;
}
.card-back-url {
	padding: 10px;
}
#app .foot div .footHrefOuter .footHref3 {
	text-align: center;
	height: 30px;
	line-height: 30px;
}
.erweima {
	margin-top: 25px;
	padding: 10px 10px 10px 0;
}
.liaojiedesc {
	margin-top: 25px;
	background-color: #ffcd74;
	width: 130px;
	text-align: center;
	color: #fff;
	cursor: pointer;
	font-size: 24px;
	font-weight: 900;
	border-radius: 5px;
	box-shadow: 0 0 5px 5px #888888;
}
.mu-card-header {
	cursor: pointer;
}
.textdesc ul li {
	color: #fff;
	font-size: 18px;
	padding: 8px;
}
.textdesc h5 {
	font-size: 20px;
	color: #fff;
}
.textdesc {
	margin-top: 50px;
}
.finger {
	background: url(/static/img/finger.png) no-repeat;
	height: 532px;
}
.phone-title {
	text-align: center;
	font-weight: 900;
	font-size: 25px;
	color: #fff;
	height: 80px;
	line-height: 100px;
	border-bottom: 5px solid #fff;
}
.phone-background {
	width: 100%;
	height: 637px;
	min-height: 637px;
	background: url(/static/img/phoneback2.png) no-repeat;
	background-size: cover;
	margin-top: 50px;
}
.el-divider__text {
	font-size: 25px !important;
	font-weight: 900 !important;
	color: #ff5a69 !important;
	font-family: inherit !important;
	font-weight: 500 !important;
	line-height: 1.1 !important;
}
.sys_pingtai {
	height: 265px;
	padding: 20px 0;
	margin-top: 10px;
}

.el-input-group__append {
	border-left: 1px solid #dcdfe6 !important;
	background-color: #5099ea !important;
	color: #fff !important;
	border-radius: 25px !important;
	padding: 0 5px !important;
}
#nav_col_img .mu-card-header-title {
	vertical-align: inherit;
}
.nav_3_img .mu-card-header {
	text-align: center;
}

.nav_3_img .mu-card-header .mu-avatar img {
	border-radius: 1%;
}
.nav_3_img .mu-card-header .mu-card-header-title {
	padding-right: 18px;
	border-radius: 1%;
	display: block;
	text-align: center;
}
.el-input__inner {
	border-radius: 25px !important;
	height: 30px !important;
	line-height: 30px !important;
}
.mu-card-header-title .mu-card-title {
	font-size: 18px;
}
.mu-tab-link-highlight {
	border-radius: 25px;
	height: 3px;
	/* background-color: #fff;*/
}
</style>
<style scoped>
.mu-tab-link {
	border-bottom: 3px rgba(0, 0, 0, 0) solid;
}

.mu-tab-link:hover {
	border-bottom: 3px red solid;
	transition: transform 0.3s, opacity 0.3s;
}
#nav_4_img .mu-card-header .mu-avatar img {
	border-radius: 1%;
}

#nav_col_img .mu-card-header .mu-avatar img {
	border-radius: 20%;
	width: 50px;
	height: 50px;
}
.el-button {
	color: #fff;
	border-radius: 25px;
}
.el-input {
	padding: 5px;
	width: 98%;
	/*background-color: #7572728a;
    border: 1px solid #8c7e7e;*/
	border-radius: 25px;
	caret-color: #fff;
}

.sys_title {
	background: url('/static/img/top-pic.png') no-repeat center top;

	height: 95px;
	margin-top: 20px;
}
.username {
	float: left;
}
.bar-name {
	color: white;
}
.row-left {
	border-right: 1px dashed rgba(0, 0, 0, 0.1);
}
.menu-active {
	border-left: 2px solid lightblue;
}
.board-left,
.board-right {
	padding: 5px;
}
.paper-draft {
	padding: 10px;
}
.list-menu {
	background: #eeeeee;
}
.sys_header,
.header_user {
	background-color: #fff;
	color: #4e2594;
	height: 78px;
}
.sys_header .mu-paper-1 {
	box-shadow: none;
	line-height: 32px;
}
.sys_header .mu-tab-active {
	color: #333;
}
.sys_header .mu-tab-link {
	color: rgba(12, 67, 95, 0.7);
}
.sys_header_tabs {
	width: 50%;
}
.sys_banner {
	height: 54vh;

	background-color: #83aedb;
	text-align: center;
}
.sys_banner img {
	height: 100%;
}
.banner_nav {
	height: 60px;
	font-size: 33px;
}
.banner_bottom {
	margin-top: -10px;
	background-color: #83aedb;
}
.head_sub_nav {
	background-color: #fff;
	padding: 4px auto;
}
.left {
	flaot: left;
}
.main_nav {
	height: 65px;
	font-size: 20px;
	background-color: #5099ea;
}
.main_nav .mu-tab-text {
	color: #fff;
}
.banner_nav_col {
	padding: 20px 0px;
}
.service_nav {
	background-color: #fff;
	color: #4e2594;
}
.service_nav .mu-tab-link {
	color: #666;
}
.main_nav .mu-tab-link {
	font-size: 16px;
}
.service_tabs_content.mu-paper-1,
.no_shadow {
	background-color: rgba(0, 0, 0, 0) !important;
	box-shadow: none;
	line-height: 32px;
}
.service_tabs_content.mu-paper-1 .service_item {
	width: 20%;
	float: left;
	cursor: pointer;
	margin: 0 2.5%;
}
.service_tabs_content.mu-paper-1 .service_item:hover {
	width: 20%;
	float: left;
	cursor: pointer;

	height: 95%;
	margin: 0 2.5%;
	margin-top: -2px;
	box-shadow: 0 10px 10px 10px #888888;
}
.bg_h {
	padding: 20px 0px;
	/*  background-color: #fff*/
}
</style>



// WEBPACK FOOTER //
// content.vue?38a5480b